export default __webpack_public_path__ + "static/media/2017.c08d1087.PNG";